import Vue from "vue";
import { defineStore } from "pinia";
import Http from "@/plugins/axios"; // não precisa de .js
import * as _ from "lodash-es";
const READ = "/company/config";

const LOGIN = "/auth/login"; //, method: 'POST', fetchUser: true },
const LOGOUT = "/auth/logout"; //, method: 'POST', redirect: '/login', makeRequest: true },
const FETCH = "/auth/user"; //, method: 'GET', enabled: true },

const CHANGE_PASSWORD = import.meta.env.VITE_SSO_URL + "/auth/change-password";

const AVATAR_REVISION_KEY = "portal.avatarRevision";

function readAvatarRevision() {
    try {
        return Number(sessionStorage.getItem(AVATAR_REVISION_KEY)) || 0;
    } catch (error) {
        return 0;
    }
}

function storeAvatarRevision(revision) {
    try {
        sessionStorage.setItem(AVATAR_REVISION_KEY, String(revision));
    } catch (error) {
        // Sessão indisponível: a troca vale até recarregar a página.
    }
}

export const useAuth = defineStore("auth", {
    // other options...
    state: () => {
        return {
            // all these properties will have their type inferred automatically
            user_data: null,
            avatarRevision: readAvatarRevision(),
        };
    },
    getters: {
        avatarSrc(state) {
            return (url) => {
                if (!url || !state.avatarRevision) {
                    return url;
                }

                const value = String(url);

                if (value.startsWith("blob:") || value.startsWith("data:")) {
                    return value;
                }

                const join = value.includes("?") ? "&" : "?";

                return `${value}${join}v=${state.avatarRevision}`;
            };
        },
    },
    actions: {
        installRoutesHooks() {
            Vue.router.beforeEach((to, from, next) => {
                const authRequired = to.matched.some((x) => {
                    return x.meta.auth;
                });

                const isAuth = this.check();

                if (authRequired && !isAuth) {
                    sessionStorage.setItem("redirectPath", to.path);
                    //next({ name: 'login' });
                    next();
                } else if (authRequired && isAuth) {
                    next();
                } else {
                    next();
                }
            });
        },
        changePassword(data) {
            return Http.post(CHANGE_PASSWORD, data);
        },

        user() {
            if (this.check()) {
                return this.user_data;
            }
            return false;
        },
        check() {
            return !_.isEmpty(this.user_data);
        },
        async load() {
            return Http.get(FETCH)
                .then(({ data }) => {
                    this.user_data = data;
                    return data;
                })
                .catch(() => {
                    this.user_data = null;
                });
        },
        async login(data) {
            return new Promise((resolve, reject) => {
                Http.post(LOGIN, data.data)
                    .then(({ data }) => {
                        if (data.status == "success") {
                            this.load().then((data) => {
                                resolve(data);
                            });
                        } else {
                            reject("nao-atenticado");
                        }
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        async refreshAvatar() {
            const current = Vue.auth && Vue.auth.user();

            if (!current) {
                return;
            }

            try {
                const { data } = await Http.get(FETCH);
                const avatar = _.get(data, "data.avatar");

                if (avatar) {
                    Vue.auth.user({ ...current, avatar });
                }
            } catch (error) {
                // O menu segue com as iniciais se o usuário do portal não puder ser lido.
            }

            this.avatarRevision += 1;
            storeAvatarRevision(this.avatarRevision);
        },
        async logout() {
            this.avatarRevision = 0;
            storeAvatarRevision(0);

            return Http.post(LOGOUT).then(({ data }) => {
                this.user_data = null;
                // GET CSRF TOKEN
                if (data.csrf_token) {
                    document.querySelector('meta[name="csrf-token"]').setAttribute('content', data.csrf_token);
                }
            });
        },
    },
});
